//# sourceMappingURL=data_source.mjs.map
/// <reference types="./data_source.d.mts" />
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $e from "../../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $store from "../../../data/store.mjs";
import { toList } from "../../../gleam.mjs";
import * as $common from "../../../view/content_library/ingestion_control/common.mjs";

function on_click(source_id, dispatch) {
  return $e.on_click(
    (_) => {
      let _pipe = source_id;
      let _pipe$1 = new $msg.UserClickedOnFetchDataPoints(_pipe);
      let _pipe$2 = new $msg.ContentLibrary(_pipe$1);
      dispatch(_pipe$2);
      return undefined;
    },
  );
}

export function view() {
  return $redraw.component_(
    "IngestionControl(InspectSource)",
    (_use0) => {
      let source_id = _use0[0];
      let store = $store.use_state();
      let dispatch = $store.use_dispatch();
      let on_click$1 = on_click(source_id, dispatch);
      return $redraw.fragment(
        toList([
          $h.div(
            toList([]),
            toList([
              $button.primary(
                toList([on_click$1]),
                toList([$h.text("Get data points")]),
              ),
            ]),
          ),
          $common.preview_source(store, source_id, new $option.None()),
        ]),
      );
    },
  );
}
